import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'UIComponents/elements/headings';
import UISection from 'UIComponents/section/UISection';
import UsersAndTeamsSelect from 'ui-asset-management-lib/components/tableFilters/UsersAndTeamsSelect';
import I18n from 'I18n';
import { useCallback } from 'react';
import { getAllParentTeamIdsForChildTeamId } from 'ui-asset-management-lib/utils/TeamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailCreationTeamAssignSelect = ({
  fetchedTeams,
  selectedTeamIds,
  setSelectedTeamIds
}) => {
  const handleChange = useCallback(teamOptions => {
    let teamIds = [];
    for (const teamOption of teamOptions) {
      const {
        id
      } = teamOption;
      teamIds = [id, ...getAllParentTeamIdsForChildTeamId(id, fetchedTeams), ...teamIds];
    }
    teamIds = Array.from(new Set(teamIds));
    setSelectedTeamIds(teamIds);
  }, [setSelectedTeamIds, fetchedTeams]);
  return /*#__PURE__*/_jsxs(UISection, {
    children: [/*#__PURE__*/_jsx(H7, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "EmailComponents.emailCreation.teamSelectTitle"
      })
    }), /*#__PURE__*/_jsx(UsersAndTeamsSelect, {
      anchorType: "button",
      buttonUse: "form",
      multi: true,
      allowPrivate: false,
      showAny: false,
      showUnassigned: false,
      showMyTeamsOption: false,
      teams: fetchedTeams,
      users: [],
      value: selectedTeamIds,
      onChange: handleChange,
      assetTypeDisplayName: I18n.text('EmailComponents.emailCreation.assetTypeDisplayName')
    })]
  });
};
export default EmailCreationTeamAssignSelect;